export default __webpack_public_path__ + "static/media/IMG-20241210-WA0013.a28774b3.jpg";